import Relay from './Relay';

export default class Listener {
    state = null;

    constructor(root) {
        this.root = root;
        this.relay = new Relay(root);
    }

    init() {
        this.relay.on('clickOnIcon');

        this.setState('create');
    }

    setState(state) {
        this.state = state;

        switch (state) {
        case 'create':
            _setStateCreate.call(this); break;
        case 'show':
            _setStateShow.call(this); break;
        case 'hide':
            _setStateHide.call(this); break;
        case 'sheet-freeze-on':
            _setStateSheetFreezeOn.call(this); break;
        case 'sheet-freeze-off':
            _setStateSheetFreezeOff.call(this); break;
        case 'time-selector-show':
            _setStateTimeSelectorShow.call(this); break;
        case 'time-selector-hide':
            _setStateTimeSelectorHide.call(this); break;
        case 'date-selector-show':
            _setStateDateSelectorShow.call(this); break;
        case 'date-selector-hide':
            _setStateDateSelectorHide.call(this); break;
        default:
            console.warn(`Listener: Unknown state - "${ this.state }"`);
        }
    }
}

function _setStateCreate() {
    // ON
    this.relay.on('resizeWindow');
    this.relay.on('onInput');

    _setStateHide.call(this);
}

function _setStateShow() {
    // OFF
    this.relay.off('focusOnInput');
    this.relay.off('clickOnOverlay');

    // ON
    setTimeout(() => {
        this.relay.on('keyupOnInput');
        this.relay.on('scrollOnCalendarList');
        this.relay.on('clickOnDay');
        this.relay.on('clickOutCalendar');
        this.relay.on('swipeController');
        this.relay.on('clickOnDateSelectorTrigger');
        this.relay.on('clickOnDateSelectorCloseBtn');
    }, 16);
}

function _setStateHide() {
    // OFF
    this.relay.off('keyupOnInput');
    this.relay.off('scrollOnCalendarList');
    this.relay.off('clickOnDay');
    this.relay.off('clickOutCalendar');
    this.relay.off('swipeController');
    this.relay.off('clickOnDateSelectorTrigger');
    this.relay.off('clickOnDateSelectorCloseBtn');

    // ON
    this.relay.on('focusOnInput');
    this.relay.on('clickOnOverlay');
}

function _setStateSheetFreezeOn() {
    // OFF
    this.relay.off('scrollOnCalendarList');
}

function _setStateSheetFreezeOff() {
    // ON
    this.relay.on('scrollOnCalendarList');
}

function _setStateTimeSelectorShow() {
    // ON
    this.relay.on('clickOnTimeSelectorCloseBtn');
    this.relay.on('clickOnTimeSelectorItem');
}

function _setStateTimeSelectorHide() {
    // OFF
    this.relay.off('clickOnTimeSelectorCloseBtn');
    this.relay.off('clickOnTimeSelectorItem');
}

function _setStateDateSelectorShow() {
    // OFF
    this.relay.off('clickOnDay');
    this.relay.off('clickOutCalendar');

    // ON
    this.relay.on('clickOutDateSelector');
    this.relay.on('clickOnDateSelector');
}

function _setStateDateSelectorHide() {
    // OFF
    this.relay.off('clickOutDateSelector');
    this.relay.off('clickOnDateSelector');

    // ON
    this.relay.on('clickOutCalendar');
    this.relay.on('clickOnDay');
}
